import React from 'react';
export const WarningColorInvertIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        preserveAspectRatio="xMinYMin slice"
        viewBox="0 0 32 32"
        focusable="false"
        height="16"
        width="16"
    >
        <path fill="none" d="M0 0h32v32H0z" />
        <path
            d="M29.82 25.94L17.25 3.72a1.45 1.45 0 0 0-2.5 0L2.18 25.94A1.4 1.4 0 0 0 3.43 28h25.14a1.4 1.4 0 0 0 1.25-2.06zM15 10h2v9h-2zm1 14a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 24z"
            fill="rgba(223, 1, 1, 1)"
        />
    </svg>
);
